import { Pipe, PipeTransform } from '@angular/core';
import _ from 'lodash';

@Pipe({
  name: 'usedInElements'
})
export class UsedInElementsPipe implements PipeTransform {

  transform(value: any, row: any, ...args: any): unknown {

    let out = 'Used in ' + value.length;

    if (value.length > 1){
      out += (row.type === 'DEVICE' ? ' devices' : ' routers') + ' with names: ' + _.join(value, ', ');
      return out;
    }

    if (value.length === 1){
      out += (row.type === 'DEVICE' ? ' device' : ' router') + ' with name: ' + value;
      return out;
    }

    out += (row.type === 'DEVICE' ? ' devices' : ' routers');
    return out;
  }

}
